module.exports = __webpack_public_path__ + "static/img/weilingqu-0.e0e50c15.png";